
import { Vue, Component } from 'vue-property-decorator';
import Uploader from '@/components/next/Uploader.vue';
import qs from 'qs';
import { save, ifSave } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { Field, Cell, CellGroup, Toast, Calendar } from 'vant';
Vue.use(Field).use(Cell).use(CellGroup).use(Calendar);
@Component({
  components: {
    Uploader,
  },
})
export default class Save extends Vue {
  name: string = '';
  phone: string = '';
  title: string = '';
  date: string = '';
  address: string = '';
  introduction: string = '';
  imgSrc: any = [];
  unionid: string | null = '';
  minDate: Date = new Date(1970, 0, 1);
  maxDate: Date = new Date(2099, 0, 31);
  save: boolean = false;
  show: boolean = false;
  downLoadUrl: string =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  async uploadImg() {
    // (this.$refs.uploaderImage as Uploader).uploadToOss().then((res) => {
    //     console.log('img urls result:', res);
    //     this.imgSrc = res;
    //   });
    // (this.$refs.uploaderImage as Uploader).uploadToOss()
    this.imgSrc = (await (
      this.$refs.uploaderImage as Uploader
    ).uploadToOss()) as string[];
  }
  async mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
    const data = {
      unionid: this.unionid,
      token: window.gettoken(),
      appkey: window.appkey,
      wdid: window.udid,
    };
    const res: any = await ifSave(data);
    if (res.code === 200) {
      this.save = true;
    }
  }
  formatDate(date: any) {
    return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
  }
  onConfirm(date: any) {
    this.show = false;
    this.date = this.formatDate(date);
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  WechatLogin() {
    const unionid = window.localStorage.getItem('unionid');
    if (!unionid) {
      if (isWeiXin() || !window.udid) {
        const appId = 'wx1949ed4a473b87ed';
        location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
          location.href,
        )}`;
      }
    }
  }

  // WechatLogin() {
  //   const { code, source } = qs.parse(location.search, {
  //     ignoreQueryPrefix: true,
  //   });
  //   if (isWeiXin() && !code) {
  //     const appId = 'wx1949ed4a473b87ed';
  //     location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
  //       location.href,
  //     )}`;
  //   }
  // }
  async submit() {
    if (!isWeiXin() && !window.udid) {
      this.$dialog
        .confirm({
          title: '友情提示',
          message: '请在上游新闻App进行投票',
          confirmButtonText: '还没装？一步安装',
          cancelButtonText: '我已安装过',
          closeOnClickOverlay: true,
        })
        .then((action) => {
          console.log(action);
          window.location.href = this.downLoadUrl;
        })
        .catch((action) => {
          console.log(action);
          if (action === 'overlay') {
            // 忽略掉点击遮罩层的关闭行为
            return;
          }
        });
      return;
    } else if (!this.save) {
      Toast('每天报名超过3次！');
      return false;
    } else if (!this.name) {
      Toast('请填写姓名！');
      return false;
    } else if (!this.phone) {
      Toast('请填写电话！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.title) {
      Toast('请填写标题！');
      return false;
    } else if (!this.date) {
      Toast('请填写拍摄时间！');
      return false;
    } else if (!this.address) {
      Toast('请填写地点！');
      return false;
    } else if (!this.introduction) {
      Toast('请填写简介！');
      return false;
    } else if (!this.imgSrc.length) {
      Toast('请上传图片！');
      return false;
    } else {
      const data = {
        name: this.name,
        phone: this.phone,
        title: this.title,
        time: this.date,
        address: this.address,
        introduction: this.introduction,
        cover: this.imgSrc.join('|'),
        unionid: this.unionid,
        token: window.gettoken(),
        appkey: window.appkey,
        udid: window.udid,
      };
      const res: any = await save(data);
      if (res.code === 200) {
        Toast(`${res.msg}`);
        setTimeout(() => {
          this.$router.go(0);
        }, 2000);
      } else {
        Toast(`${res.msg}`);
      }
    }
  }
}
